import React, { ChangeEventHandler, KeyboardEvent } from 'react';
import {
  StyledButton,
  StyledButtonWrap,
  StyledContainer,
  StyledInput,
  StyledPageInfo,
  StyledPageSizeSelect,
  StyledSelect,
  StyledWrapper,
} from './styles';

type Props = {
  onNext: () => void;
  onPrev: () => void;
  onPageSelect: ChangeEventHandler<HTMLSelectElement>;
  onEnter: (e: KeyboardEvent<HTMLInputElement>) => void;
  hasNext: boolean;
  hasPrev: boolean;
  pageIndex: number;
  pageSize: number;
  maxPageSize: number;
};

const Pagination = ({
  onNext,
  onPrev,
  onPageSelect,
  onEnter,
  hasNext,
  hasPrev,
  pageIndex,
  pageSize,
  maxPageSize,
}: Props): JSX.Element => {
  return (
    <StyledContainer>
      <StyledButtonWrap>
        <StyledButton onClick={onPrev} disabled={!hasPrev}>
          이전
        </StyledButton>
      </StyledButtonWrap>
      <StyledWrapper>
        <StyledPageInfo>
          페이지
          <StyledInput
            key={pageIndex}
            type="number"
            min="1"
            max={maxPageSize}
            defaultValue={pageIndex + 1}
            onKeyDown={onEnter}
          />
          / <span className="total-page">{maxPageSize}</span>
        </StyledPageInfo>
        <StyledPageSizeSelect>
          <StyledSelect value={pageSize} onChange={onPageSelect}>
            {[100, 150, 200, 500].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                {pageSize}
              </option>
            ))}
          </StyledSelect>
        </StyledPageSizeSelect>
      </StyledWrapper>
      <StyledButtonWrap>
        <StyledButton onClick={onNext} disabled={!hasNext}>
          다음
        </StyledButton>
      </StyledButtonWrap>
    </StyledContainer>
  );
};
export default Pagination;
